
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 73 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.5 37.5V20.4C60.5 15.3595 60.5 12.8393 59.5191 10.9141C58.6562 9.22063 57.2794 7.8438 55.5859 6.98094C53.6607 6 51.1405 6 46.1 6H26.9C21.8595 6 19.3393 6 17.4141 6.98094C15.7206 7.8438 14.3438 9.22063 13.4809 10.9141C12.5 12.8393 12.5 15.3595 12.5 20.4V51.6C12.5 56.6405 12.5 59.1607 13.4809 61.0859C14.3438 62.7794 15.7206 64.1562 17.4141 65.0191C19.3393 66 21.8594 66 26.8996 66H38M42.5 33H24.5M30.5 45H24.5M48.5 21H24.5M45.5 57L54.5 46M54.5 46L63.5 57M54.5 46V66","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    